import { defineStore } from 'pinia';

export const useDarkModeStore = defineStore('dark', {
    state: () => ({
        isDarkMode: localStorage.getItem('dark') === "false" ? false : true,
    }),
    actions: {
      toggleDarkMode() {
        this.isDarkMode = !this.isDarkMode;
        return
      },
      // Other actions...
    },
});